import React, { useEffect, useState, useContext } from 'react'
import { formatDateToMMDDYYYY, HideLoder, ShowLoder } from '../../../JS/Common'
import { CSVLink } from 'react-csv'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { ApiGetCall } from '../../../JS/Connector'
import useConfig from '../../../Hooks/useConfig'

export default function ExportSchoolProfile({ FilterData }) {
    const { organization, team_start_date } = useConfig();
    const [loading, setLoading] = useState(false);
    const [SchoolProfileDataCsv, setSchoolProfileDataCsv] = useState([]);
    const [divVisibleForExport, setDivVisibleForExport] = useState({
        dataAvailable: false,
        noData: false
    });
    const [pricingValue, setPricingValue] = useState(null);
    const [routeValue, setRouteValue] = useState(null);
    const [customerValue, setCustomerValue] = useState(null);
    const [relationshipValue, setRelationshipValue] = useState(null);
    const [pricingData, setPricingData] = useState([]);
    const [routeFrequencyData, setRouteFrequencyData] = useState([]);
    const [relationShipData, setRelationShipData] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    useEffect(() => {
        async function GetSchoolProfileExportOptions() {
            setLoading(true);
            await ApiGetCall("/schools/profile/export-options").then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setPricingData(responseRs?.repair_price_tier);
                    setRouteFrequencyData(responseRs?.route_frequency);
                    setRelationShipData(responseRs?.relationship_manager);
                    setCustomerData(responseRs?.customer);
                }
            });
        }
        GetSchoolProfileExportOptions();
    }, []);
    const headers = [
        { label: `${organization} Name`, key: "school_name" },
        { label: "Domain(s)", key: "domain" },
        { label: "Main Contact Email", key: "contact_email" },
        { label: "Main Contact First Name", key: "contact_first_name" },
        { label: "Main Contact Last Name", key: "contact_last_name" },
        { label: "Main Contact Job Title", key: "job_title" },
        { label: "Main Contact Phone Number", key: "phone_number" },
        { label: "Main Contact Ext", key: "phone_number_ext" },
        { label: "Preferred Method Of Contact", key: "method_of_contact_main" },
        { label: team_start_date, key: "k12_team_start_date" },
        { label: "Relationship Manager", key: "relationship_manager" },
        { label: "Location Manager", key: "location_manager" },
        { label: "Driver", key: "driver" },
        { label: "Enrollment", key: "enrollment" },
        { label: "Customer", key: "customer" },
        { label: `Shipping - Company/${organization} Name`, key: "fedex_shipping_company_name" },
        { label: "Shipping - Phone Number", key: "shipping_phone_number" },
        { label: "Shipping - Phone Number Ext", key: "shipping_phone_number_ext" },
        { label: "Shipping - Street Line 1", key: "shipping_street_line1" },
        { label: "Shipping - Street Line 2", key: "shipping_street_line2" },
        { label: "Shipping - City", key: "shipping_city" },
        { label: "Shipping - State", key: "shipping_state" },
        { label: "Shipping - Zip Code", key: "shipping_postal_code" },
        { label: "Local Pick-Up/Dropoff Location(s)", key: "pick_up_location" },
        { label: "Billing - First Name", key: "billing_first_name" },
        { label: "Billing - Last Name", key: "billing_last_name" },
        { label: "Billing - Email", key: "billing_email" },
        { label: "Billing - Phone Number", key: "billing_phone_number" },
        { label: "Billing - Phone Number Ext", key: "billing_phone_number_ext" },
        { label: "Billing - Company Name", key: "billing_company_name" },
        { label: "Billing - Street Line 1", key: "billing_street_line1" },
        { label: "Billing - Street Line 2", key: "billing_street_line2" },
        { label: "Billing - City", key: "billing_city" },
        { label: "Billing - State", key: "billing_state" },
        { label: "Billing - Zip Code", key: "billing_postal_code" },
        { label: "Account Credit", key: "account_credit" },
        { label: "Account Credit Usage", key: "account_credit_usage" },
        { label: "Special Discounts or Pricing", key: "special_discounts_or_pricing" },
        { label: "Devices in District", key: "devices_in_district" },
        { label: "Loaner Device Percentage", key: "loaner_device_percentage" },
        { label: "Weekly Repairs", key: "weekly_repairs" },
        { label: "Repair Notes", key: "repair_notes" },
        { label: "Minimum Repair Grade", key: "minimum_repair_grade" },
        { label: "Repair Price Tier", key: "repair_price_tier" },
        { label: "Quoting Needed?", key: "quoting_needed" },
        { label: "Deductible?", key: "deductible" },
        { label: "Deductible Notes", key: "deductible_notes" },
        { label: "Cosmetic Damage Repaired?", key: "cosmetic_damage_repaired" },
        { label: "Cosmetic Damage Notes", key: "cosmetic_damage_notes" },
        { label: "Damage Repaired", key: "damage_repaired" },
        { label: "Pick-Up Day", key: "route_day" },
        { label: "Route Frequency", key: "route_frequency" },
        { label: "Uncovered Device Handling", key: "uncovered_device_handling" },
        { label: "Additional Asset Management System", key: "additional_asset_management_system" },
        { label: "Repair Coverage", key: "repair_coverage" },
    ];
    const csvReport = {
        filename: `${organization}ProfilePricing.csv`,
        headers: headers,
        data: SchoolProfileDataCsv,
    };
    async function ExportProfile() {
        setLoading(true);
        await ApiGetCall(`/schools/profile/export?priceId=${pricingValue}&routeId=${routeValue}&managerId=${relationshipValue}&customerId=${customerValue}&startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length != 0) {
                    setSchoolProfileDataCsv(responseRs);
                    setDivVisibleForExport({ ...divVisibleForExport, dataAvailable: true, noData: false });
                } else {
                    setSchoolProfileDataCsv([]);
                    setDivVisibleForExport({ ...divVisibleForExport, noData: true, dataAvailable: false });
                }
                setLoading(false);
            }
        });
    }
    function RemoveUserCsv() {
        setSchoolProfileDataCsv([]);
        setDivVisibleForExport({ ...divVisibleForExport, dataAvailable: false, noData: false });
    }
    return (
        <div>
            {loading ? <ShowLoder /> : <HideLoder />}

            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Export Service Profile</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    Would you like to export your Service Profile data? To do so, simply click on the 'Export Service Profile' button.
                </p>
                <div className='row'>
                    <div className='col-md-6'>
                        <select onChange={(e) => setPricingValue(e.target.value == 0 ? null : e.target.value)}>
                            <option value="0">Filter by Pricing</option>
                            {pricingData?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.data}</option>
                            })}
                        </select>
                    </div>
                    <div className='col-md-6'>
                        <select onChange={(e) => setRouteValue(e.target.value == 0 ? null : e.target.value)}>
                            <option value="0">Filter by Route Frequency</option>
                            {routeFrequencyData?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.data}</option>
                            })}
                        </select>
                    </div>
                    <div className='col-md-6 pt-3'>
                        <select onChange={(e) => setCustomerValue(e.target.value == 0 ? null : e.target.value)}>
                            <option value="0">Filter by Customer</option>
                            {customerData?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.data}</option>
                            })}
                        </select>
                    </div>
                    <div className='col-md-6 pt-3'>
                        <select onChange={(e) => setRelationshipValue(e.target.value == 0 ? null : e.target.value)}>
                            <option value="0">Filter by Relationship Manager</option>
                            {relationShipData?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.first_name} {item.last_name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="row pt-3 pb-2 px-3">
                    <div className="col-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={ExportProfile}>Export Service Profile
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>

                </div>
                {divVisibleForExport.dataAvailable &&
                    <div className="row pt-2" >
                        <div>Your Service Profile CSV file is now ready for download. Please click the button below to initiate the file download.</div>
                        <div className="col-12 mt-1 text-center">
                            <label style={{ fontSize: "12px", color: "#04ADFD" }} id="ExportedStudentFileName">
                                {organization}ProfilesPricings.csv
                            </label>
                            <CSVLink {...csvReport} className="WhiteFont"> <button className='SaveBtn ms-4'>Download</button></CSVLink>
                            <FontAwesomeIcon icon={faCircleXmark} className="cursor-pointer ps-3" onClick={RemoveUserCsv} />
                        </div>
                    </div>
                }
                {divVisibleForExport.noData &&
                    <div className="row pt-2">
                        <div className="custom-text-danger">No Record Found!</div>
                    </div>
                }
            </div>

        </div>
    )
}
